import Vue from 'vue';

Vue.component('accordion-component', {
  props: ['shouldToggle', 'accData'],
  data() {
    const accItems = this.accData.map(item => Object.assign(item, { isOpen: false }));
    const accToggles = this.shouldToggle;

    return {
      items: accItems,
      toggles: accToggles,
    };
  },
  template: `<div class="c-accordion">
              <div class="c-accordion__item" v-for="item in items">
                <div class="c-accordion__title"
                  v-bind:class="{ 'm--active': item.isOpen }"
                  v-html="item.title"
                  v-on:click="toggle(item)"
                ></div>
                <div class="c-accordion__content"
                  v-show="item.isOpen"
                  v-html="item.content"
                ></div>
              </div>
            </div>`,
  methods: {
    toggle(item) {
      this.mapOverItems(item.id, 'toggle', item.isOpen);
    },
    show(item) {
      this.mapOverItems(item.id, 'show');
    },
    hide(item) {
      this.mapOverItems(item.id, 'hide');
    },
    mapOverItems(itemID, toggleType, state) {
      const toggleTypes = {
        show: true,
        hide: false,
        toggle: !state,
      };

      this.items = this.items.map((item) => {
        if (item.id === itemID) {
          Object.assign(item, { isOpen: toggleTypes[toggleType] });
        } else if (this.toggles) {
          Object.assign(item, { isOpen: false });
        }
        return item;
      });
    },
  },
});



// WEBPACK FOOTER //
// ./app/js/components/accordion-component.js